import React from 'react';

function Contratos() {
  return (
    <div className="contratos-page">
      <div className="container">
        <div className="section-header">
          <h1>Contratos</h1>
          <p>Documentos legais da UNET Internet e Banda Larga</p>
        </div>
        
        <div className="contratos-grid">
          <div className="contrato-card">
            <div className="contrato-icon">
              <i className="fas fa-file-pdf"></i>
            </div>
            <h3>Contrato de Comodato de Equipamentos</h3>
            <p>Documento que estabelece as condições para o empréstimo de equipamentos.</p>
            <a 
              href="/contrato-comodato.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-download"
            >
              <i className="fas fa-download"></i>
              Visualizar PDF
            </a>
          </div>
          
          <div className="contrato-card">
            <div className="contrato-icon">
              <i className="fas fa-file-pdf"></i>
            </div>
            <h3>Contrato de Prestação de Serviço de Telecomunicações</h3>
            <p>Documento que estabelece as condições para a prestação de serviços de internet.</p>
            <a 
              href="/contrato-prestacao.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-download"
            >
              <i className="fas fa-download"></i>
              Visualizar PDF
            </a>
          </div>
        </div>
        
        <div className="contratos-info">
          <h3>Informações Importantes</h3>
          <ul>
            <li>Os contratos são documentos legais oficiais da UNET</li>
            <li>Recomendamos a leitura completa antes de assinar</li>
            <li>Em caso de dúvidas, entre em contato conosco</li>
            <li>Os documentos estão em formato PDF para melhor visualização</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Contratos; 